// src/config.js
const configs = {
    local: "http://localhost:4000", // Localhost API base URL
    development: "https://xunit.whizbanginfotech.com", // Development API base URL
    production: "https://wappcommunicationapi.whizbanginfotech.com", // Production API base URL
};

const getBaseUrl = () => {
    const hostname = window.location.hostname;
    
    if (hostname === "localhost") {
        return configs.local;
    } else if (hostname.includes("nunit")) {
        return configs.development;
    } else {
        return configs.production;
    }
};

export const BASE_URL = getBaseUrl();
